// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_PreviewInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_PreviewInput — body for POST /franchisor-channels/preview.
 *
 * Renders a stored template with example values and sends NOTHING — no
 * adapter, no socket, no `franchisor_channel_messages` row. That is why
 * preview does not check the subscription gate that test-send does
 * (chamado 2026-0043): there is no delivery to block.
 *
 * `vars` is an optional override map merged ON TOP of the trigger's
 * `sample_vars` (FranchisorTriggerCatalog). Omitting it previews with the
 * samples alone; sending a partial map replaces only those keys.
 */
import { registerContract } from './validate'

export interface FranchisorChannels_PreviewInput {
template_id: number
vars?: Record<string, string>
}

registerContract('FranchisorChannels_PreviewInput', {
  template_id: { type: 'number',  required: true },
  vars:        { type: 'object',  required: false },
})
